import React from 'react';
import { StarIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { PageHero } from '../components/ui/PageHero';
import { TESTIMONIALS } from '../lib/site';
import { Reveal } from '../components/fx/Reveal';
import { Testimonials } from '../components/sections/Testimonials';
import { EmergencyCTA } from '../components/sections/EmergencyCTA';
export function Reviews() {
  return <>
      <PageHero eyebrow="Reviews" title="Loved by Houston Families" subtitle="Rated 5.0 stars across Google. Here's what our clients say about working with Dream Shield." crumbs={[{
      label: 'Home',
      to: '/'
    }, {
      label: 'Reviews'
    }]} data-id="element-495" data-mp="we6fg2vzvz13" />

      <section className="mx-auto max-w-7xl px-6 py-8" data-id="element-496" data-mp="rh7izdouzfzq">
        <div className="grid gap-6 md:grid-cols-2" data-id="element-497" data-mp="3837fvk3e7igd">
          {[...TESTIMONIALS, ...TESTIMONIALS].slice(0, 6).map((t, i) => <Reveal key={i} delay={i % 2 * 0.1} data-id="element-498" data-mp="3c3hj4ozsvurj" data-mpi={i}>
              <motion.div whileHover={{
            y: -6
          }} className="glass-strong h-full rounded-[2rem] p-8 shadow-glass transition-shadow hover:shadow-glow" data-id="element-499" data-mp="2oy2t01r40e3">
                <div className="flex gap-1" data-id="element-500" data-mp="brqrqwngo00r">
                  {Array.from({
                length: t.rating
              }).map((_, j) => <StarIcon key={j} className="h-4 w-4 fill-yellow-400 text-yellow-400" data-id="element-501" data-mp="lo29411wrg22" data-mpi={j} />)}
                </div>
                <p className="mt-4 text-base leading-relaxed text-navy" data-id="element-502" data-mp="vews8wjuxzja">
                  "{t.quote}"
                </p>
                <div className="mt-6 flex items-center gap-3" data-id="element-503" data-mp="qgmx2ly4uyxo">
                  <span className="flex h-11 w-11 items-center justify-center rounded-full bg-royal/10 font-display font-bold text-royal" data-id="element-504" data-mp="14etllbh6zmko">
                    {t.name.charAt(0)}
                  </span>
                  <div data-id="element-505" data-mp="3t8i2hmcjxylm">
                    <p className="font-semibold text-navy" data-id="element-506" data-mp="3t918c4oxgwja">{t.name}</p>
                    <p className="text-xs text-slate" data-id="element-507" data-mp="21f86m1f3c76">{t.location}</p>
                  </div>
                </div>
              </motion.div>
            </Reveal>)}
        </div>
      </section>

      <Testimonials data-id="element-508" data-mp="auikus48nl0r" />
      <EmergencyCTA data-id="element-509" data-mp="av0owax573j8" />
    </>;
}